import styled from 'styled-components'

type Props = {
	isCentered?: boolean
}

export const Body = styled.div<Props>`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	padding-top: 24px;
	max-width: ${({ isCentered = false }) => isCentered && '432px'};
	margin: ${({ isCentered = false }) => isCentered && '0 auto'};
`
